import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'
import { MfDestination, MfDestinationFormPayload } from 'types/mf_kessai'

const resource = 'billings'

export const requests = {
  fetchMe: async () => {
    return await axiosForGigbaseBiz.get<DataResponse<MfDestination>>(
      mergeURL(resource, 'me'),
    )
  },
  update: async (payload: MfDestinationFormPayload) => {
    return await axiosForGigbaseBiz.patch<DataResponse<MfDestination>>(
      resource,
      payload,
    )
  },
}
